import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../api";
import SEO from "../components/SEO";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/blog/posts")
      .then(({ data }) => setPosts(data))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-6 py-20">
      <SEO
        title="Research Library — Peptide Mechanisms & Preclinical Studies"
        description="In-depth research articles on peptides: mechanisms of action, preclinical study reviews, and comparison analyses. For licensed researchers and biochemistry students."
        path="/research-library"
        keywords="peptide research library, peptide research articles, peptide mechanism of action, peptide research guides, BPC-157 research, GLP-1 peptide research"
      />
      <div className="overline">RESEARCH LIBRARY</div>
      <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl mt-3 mb-4 font-light">
        Research articles for<br />
        <span className="text-[#00C3FF]">serious peptide researchers.</span>
      </h1>
      <p className="text-[#8A94A6] text-lg max-w-2xl mb-14">
        Mechanism-of-action deep dives, preclinical study reviews, and comparison analyses. Written for the research community. Never medical advice.
      </p>

      {loading ? (
        <div className="text-[#5C657A] font-mono-tech text-sm">Loading articles…</div>
      ) : posts.length === 0 ? (
        <div className="border border-white/10 p-10 text-center text-[#5C657A]" data-testid="blog-empty">
          <div className="font-mono-tech text-xs uppercase tracking-wider mb-2">RESEARCH LIBRARY IS OPENING SOON</div>
          <p className="text-sm">First articles are being published shortly. Check back in a few days.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-list">
          {posts.map((p) => (
            <Link
              key={p.slug}
              to={`/research-library/${p.slug}`}
              className="group border border-white/10 hover:border-[#00C3FF]/60 transition-colors p-6 flex flex-col gap-3"
              data-testid={`blog-card-${p.slug}`}
            >
              {p.cover_image && (
                <img src={p.cover_image} alt={p.title} className="w-full h-40 object-cover mb-2" loading="lazy" />
              )}
              <div className="overline">{(p.tags || [])[0] || "RESEARCH"}</div>
              <h2 className="font-heading text-xl leading-tight text-white group-hover:text-[#00C3FF] transition-colors">
                {p.title}
              </h2>
              <p className="text-sm text-[#8A94A6] flex-1">{p.excerpt}</p>
              <div className="text-[10px] font-mono-tech text-[#00C3FF] uppercase tracking-wider flex items-center gap-2 mt-2">
                Read article <ArrowRight size={11} />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
